module.exports = __webpack_public_path__ + "media/stylesheets/images/main/chrome-b46490273c2d4a188a8e5106b4171cf3.svg";